// Content access layer. Components read content ONLY through these functions.
// To move to headless WordPress later, replace these implementations with
// fetch calls to the WP REST API — no component changes required.
import { stories } from "../content/stories";
import { events } from "../content/events";
import { activities } from "../content/activities";
import { pillars, pillarOrder } from "../content/pillars";
import { teamMembers } from "../content/team";
import { supporters } from "../content/supporters";

export const getStories = () =>
  [...stories].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));

export const getLatestStories = (n = 3) => getStories().slice(0, n);

export const getStoryBySlug = (slug) => stories.find((s) => s.slug === slug);

export const getRelatedStories = (story, n = 2) =>
  getStories()
    .filter((s) => s.slug !== story.slug)
    .sort((a, b) => (b.category === story.category ? 1 : 0) - (a.category === story.category ? 1 : 0))
    .slice(0, n);

export const getUpcomingEvents = (n) =>
  events
    .filter((e) => e.status === "upcoming")
    .sort((a, b) => a.startDate.localeCompare(b.startDate))
    .slice(0, n || undefined);

export const getPastEvents = () =>
  events
    .filter((e) => e.status === "past")
    .sort((a, b) => b.startDate.localeCompare(a.startDate));

export const getEventBySlug = (slug) => events.find((e) => e.slug === slug);

export const getActivities = () => activities;

export const getActivityBySlug = (slug) => activities.find((a) => a.slug === slug);

export const getActivityEvents = (slug) => events.filter((e) => e.relatedActivity === slug);

export const getActivityStories = (slug) => stories.filter((s) => s.relatedActivity === slug);

export const getPillar = (key) => pillars[key];

export const getPillarOrder = () => pillarOrder;

export const getPillarEvents = (key) => events.filter((e) => e.pillar === key);

export const getPillarStories = (key) => stories.filter((s) => s.category === key);

export const formatDate = (iso, opts) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    ...opts,
  });

export const pillarLabel = (key) =>
  ({ animals: "Animals", people: "People", nature: "Nature", community: "Community", "from-pilcoo": "From PilCoo", perspective: "Perspective" }[key] || key);

export const pillarColor = (key) =>
  ({ animals: "#43D2FF", people: "#FF2F89", nature: "#FFC300", community: "#1C1917" }[key] || "#1C1917");

export const getTeam = () => [...teamMembers].sort((a, b) => a.order - b.order);

export const getSupporters = () => supporters;
